import { render, staticRenderFns } from "./RecentActivityItem.vue?vue&type=template&id=941a171a"
import script from "./RecentActivityItem.vue?vue&type=script&lang=js"
export * from "./RecentActivityItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports